import { Controller } from "react-hook-form";
import { Box, FormControl, FormHelperText } from "@mui/material";
import { SubmitButton } from "../../../SignUp/partials/SubmitButton";
import { FormLabel, Input } from "../../../../components";
import { useResetPassword } from "../../hooks/useResetPassword";

type TResetPasswordFormProps = {
  onSuccess: ({ email }: { email: string }) => void;
};

export const ResetPasswordForm = ({ onSuccess }: TResetPasswordFormProps) => {
  const { errors, control, isSubmitting, onSubmit } = useResetPassword({
    onSuccess,
  });

  return (
    <Box component="form" width="100%" onSubmit={onSubmit} noValidate>
      <Controller
        control={control}
        name="email"
        render={({ field, fieldState }) => (
          <FormControl
            error={fieldState.invalid}
            sx={{ width: "100%", mb: 3.5 }}
          >
            <FormLabel htmlFor="email">Email</FormLabel>
            <Input
              {...field}
              fullWidth
              disabled={isSubmitting}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              id="email"
              type="email"
              placeholder="Enter your email"
            />
          </FormControl>
        )}
      />
      <SubmitButton
        type="submit"
        disabled={isSubmitting}
        loading={isSubmitting}
      >
        Reset Password
      </SubmitButton>

      {Object.entries(errors).map(([key, error]) => {
        if (!error) return null;
        return (
          <FormHelperText error key={key}>
            {error}
          </FormHelperText>
        );
      })}
    </Box>
  );
};
